import { useState } from "react";
import { useParams } from "react-router-dom";
import { LinearErrorFileText } from "../../pages/linear/LinearHelpRequestText";
import { selectCommunicationData } from "../../store";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { CommunicationType, FileItemType } from "../../types/communication/communicationDataType";
import { uploadExecutionHandler } from "../../utils/utils-file";
import { LinearInfoModal } from "../cai-info-modal/LinearInfoModal";
import { RealtimeModal } from "../modal/RealtimeModal";
import { Vspace } from "../styled/Separators.style";
import LinearError from './../../assets/img/linearError.svg';
import FileListCmp from "./FileListCmp";
import FileUploadCmp from "./FileUploadCmp";

interface FilesUploadListCmpProps {
    files: FileItemType[];
    setFiles: any,
    fileType: string;
    arrayDbPropSync?: string;
    textLabel?: string;
    companyName?: string;
    maxLimit?: number;
    alreadySentDocIds?: string[]
    isInMultiCard?: boolean
    customUpdateDbCommunicationFileList?: any
    onPreUploadCallback?: (file: File) => boolean;
}

const FilesUploadListCmp = (props: FilesUploadListCmpProps) => {
    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const { token } = useParams();
    const { files, setFiles, fileType, arrayDbPropSync, textLabel, companyName, maxLimit, alreadySentDocIds, isInMultiCard,
        customUpdateDbCommunicationFileList, onPreUploadCallback
    } = props
    const [tooBigFileModal, setTooBigFileModal] = useState(false);

    const updateDbCommunicationFileList = (newFileList: FileItemType[]) => {
        if (customUpdateDbCommunicationFileList) {
            customUpdateDbCommunicationFileList(newFileList)
            return
        } else if (arrayDbPropSync) {
            const updComm: any = new CommunicationType(communication)
            updComm[arrayDbPropSync] = newFileList
            dispatch(saveCommunicationAct({
                data: updComm
            })
            )
        }
    }

    const onFileUpsertHandler = (_file?: FileItemType) => {
        if (!_file) {
            return _file
        }

        setFiles((currentFiles: FileItemType[]) => {
            let fileFound = false
            const newFiles = currentFiles.map((file: FileItemType) => {
                if ((_file._id === file._id) ||
                    (_file.name === file.name && !file._id)
                ) {
                    fileFound = true;
                    return _file
                } else {
                    return file
                }
            }) || []
            let newFilesArray = []
            if (fileFound) {
                newFilesArray = [...newFiles]
            } else {
                newFilesArray = [...newFiles, _file]
            }

            // sync db array prop, if present
            if (_file._id) {
                updateDbCommunicationFileList(newFilesArray)
            }
            return newFilesArray
        })
    }

    const onFileRemovedHandler = (_file?: FileItemType) => {
        if (!_file) {
            return _file
        }

        setFiles((currentFiles: FileItemType[]) => {
            const newFilesArray = currentFiles.filter((file: FileItemType) => file._id !== _file._id)
            updateDbCommunicationFileList(newFilesArray)
            return newFilesArray;
        })
    }

    // Wrapper personalizzato per l'upload che include il callback pre-upload
    const customUploadHandler = (event: any) => {
        let isTooBig: boolean = false
        const file = event.target.files[0];
        if (!file) return;
        // Chiama il callback pre-upload se fornito
        if (onPreUploadCallback) {
            isTooBig = onPreUploadCallback(file);
            if (isTooBig) {
                // ripulisce il target value
                event.target.value = null;
                setTooBigFileModal(isTooBig);
                return;
            }
        }
        !isTooBig && uploadExecutionHandler(event, fileType, token, onFileRemovedHandler, onFileUpsertHandler);
    }

    const classNameUpload = (filesLength: number) => {
        if (companyName === "LINEAR") {
            return "file-upload-button"
        }
        let classNameUp = "foto-contesto-file-upload";
        return filesLength === 0 ? classNameUp : "foto-contesto-file-upload wrapped"
    }
    const fileUploadCmp = <FileUploadCmp
        companyName={companyName}
        files={files}
        onFileAdded={onFileUpsertHandler}
        onFileRemoved={onFileRemovedHandler}
        className={classNameUpload(files?.length)}
        fileType={fileType}
        textLabel={textLabel}
        maxLimit={maxLimit}
        isInMultiCard={isInMultiCard}
        customUploadHandler={onPreUploadCallback ? customUploadHandler : undefined}
    />

    return (
        <>
            {companyName === "LINEAR" ? <RealtimeModal
                companyName={communication?.companyName}
                modalOpened={tooBigFileModal}
                hTitle="ERRORE CARICAMENTO"
                hCloseButton={true}
                /* istanbul ignore next */
                onCloseHandler={() => setTooBigFileModal(false)}>
                <LinearInfoModal
                    close={() => setTooBigFileModal(false)}
                    additionalImage={LinearError}
                    text={<LinearErrorFileText />}
                    buttonTxt={"Chiudi"}
                />
            </RealtimeModal> : <></>}
            {files?.length === 0 ? fileUploadCmp : <></>}
            {companyName !== "LINEAR" && <Vspace qty={2}></Vspace>}
            <FileListCmp
                children={files?.length ? fileUploadCmp : <></>}
                files={files}
                onFileRemoved={onFileRemovedHandler}
                className={"foto-contesto-file-upload " + companyName}
                companyName={companyName}
                alreadySentDocIds={alreadySentDocIds}
                isInMultiCard={isInMultiCard}
            />
            {companyName !== "LINEAR" && <Vspace qty={2}></Vspace>}
        </>
    )
}

export default FilesUploadListCmp